import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import { Link } from 'gatsby';
import EbookExample from '~/examples/ebook';
import { SourceCode } from '~/ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <p>{`A simple implementation of an Ebook using `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{`.  This example only focuses on bookmark features. Other useful Ebook features (e.g. searching, saving) can be implemented and explored in the `}<Link to="/examples/doc-preview" mdxType="Link">{`Doc preview`}</Link>{` example.`}</p>
    <SourceCode source="examples/ebook" mdxType="SourceCode" />
    <h3 {...{
      "id": "features"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Select text in a document to add bookmarks.`}</li>
      <li parentName="ul">{`Clicking on a bookmark will jump to where it occurs in the document and apply a brief highlight effect.`}</li>
      <li parentName="ul">{`Remove bookmarks using the bookmark manager, or by clicking on bookmarks in the document.`}</li>
      <li parentName="ul">{`Bookmarks can be visually customized.`}</li>
    </ul>
    <h3 {...{
      "id": "concepts"
    }}>{`Concepts`}</h3>
    <ul>
      <li parentName="ul">{`Controlled management of `}<inlineCode parentName="li">{`marks`}</inlineCode>{` (bookmarks) with a `}<inlineCode parentName="li">{`doc`}</inlineCode>{` instance.`}</li>
      <li parentName="ul">{`Apply custom `}<inlineCode parentName="li">{`mark`}</inlineCode>{` CSS.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`mark`}</inlineCode>{` anchorlinks.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`mark`}</inlineCode>{` tooltips.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.highlight()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.registerMarks()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`dom.selectText()`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`options.marks`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`options.sanitizeSchema`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "demo"
    }}>{`Demo`}</h3>
    <EbookExample mdxType="EbookExample" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      